import React, {useState, useEffect} from 'react'
import Box from './Box';
import { getAllPokemon, getPokemon } from './service';
import { Nav, NavCon, NavRow, Navbtn, Search, Btn} from './NavbarElements'
import './Main.css'
import ball from"./pok.png"
import axios from 'axios';
import { withRouter } from "react-router";
import {FaSearch} from "react-icons/fa"
import "./Box.css"
function Main() {
const [pokemonData, setPokemonData] = useState([]);
const [loading, setLoading] = useState(false);
const initialUrl = 'https://pokeapi.co/api/v2/';
const [reg, setReg] = useState(false)
const [typ, setTyp] = useState(false)
const [ser, setSer] = useState(false)
const [home, setHome] = useState(true)
const [allData,setAllData] = useState([]);
const [filteredData,setFilteredData] = useState(allData);

///////////////////SEARCH COMPONENT//////////////////////

const handleSearch = (event) => {
  let value = event.target.value.toLowerCase();
  let result = [];
  result = allData.filter((data) => {
  return data.name.search(value) != -1;
  });
  setFilteredData(result);
  console.log(result)
  }

useEffect(() => {
axios('https://pokeapi.co/api/v2/pokemon?limit=900&offset=0')
.then(response => {
setAllData(response.data.results);
setFilteredData(response.data.results);
})
.catch(error => {
  setFilteredData(allData)
console.log('Error getting fake data: ' + error);
})
}, []);

const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      search()
    }
  }

const search = async() => {
  setHome(false)
  setLoading(true);
  await loadingPokemon(filteredData)
  setLoading(false)
}
//////////////////////////////////NAVBAR COMPONENT///////////////////
const Home = () =>{
    setSer(false)
    setTyp(false)
    setReg(false)
    setHome(true)
    setFilteredData(allData)
    setPokemonData([])
}
  const BReg = () =>{
    if(reg==false){
      setSer(false)
      setTyp(false)
      setReg(true)
      setHome(false)
    setFilteredData(allData)
    }else{
      setReg(false)
    }
  }
  const BTyp = () =>{
    if(typ==false){
      setSer(false)
      setTyp(true)
      setReg(false)
      setHome(false)
    setFilteredData(allData)
    }else{
      setTyp(false)
    }
  }
  const BSer = () =>{
    if(ser==false){
      setSer(true)
      setTyp(false)
      setReg(false)
      setHome(false)
      setFilteredData(allData)
    }else{
      setSer(false)
    }
  }
/////////////////////////////////REGION COMPONENT////////////////
const kanto = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=151&offset=0')
  await loadingPokemon(data.results)
  setLoading(false)
}

const joto = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=100&offset=151')
  await loadingPokemon(data.results)
  setLoading(false)
}

const hoenn = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=135&offset=251')
  await loadingPokemon(data.results)
  setLoading(false)
  
}

const sinnoh = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=108&offset=386')
  await loadingPokemon(data.results)
  setLoading(false)
  
}

const unova = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=155&offset=494')
  await loadingPokemon(data.results)
  setLoading(false)
  setReg(false)
}

const kalos = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=122&offset=649')
  await loadingPokemon(data.results)
  setLoading(false)
  setReg(false)
}

const alola = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=88&offset=721')
  await loadingPokemon(data.results)
  setLoading(false)
  setReg(false)
}

const galar = async() => {
  setReg(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'pokemon?limit=89&offset=809')
  await loadingPokemon(data.results)
  setLoading(false)
  setReg(false)
}
////////////////////////////////////////TYPES COMPONENT/////////////
const Te1 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/1')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}
const Te2 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/2')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te3 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/3')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te4 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/4')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te5 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/5')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te6 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/6')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te7 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/7')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te8 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/8')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te9 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/9')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te10 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/10')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te11 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/11')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te12 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/12')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te13 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/13')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te14 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/14')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te15 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/15')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te16 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/16')
  await loadingPokemon2(data.pokemon)
  setLoading(false)
}

const Te17 = async() => {
  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/17')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}

const Te18 = async() => {

  setTyp(false)
  setLoading(true);
  let data = await getAllPokemon(initialUrl+'type/18')
  await loadingPokemon2(data.pokemon)
  setLoading(false) 
}
///////////////////////////Loading Component///////////////////
const loadingPokemon2 = async data => {
  let _pokemonData = await Promise.all(
    data.map(async pokemon => {
    let pokemonRecord = await getPokemon(pokemon.pokemon.url);
    return pokemonRecord
  }))
  setPokemonData(_pokemonData)
}
const loadingPokemon = async data => {
  let _pokemonData = await Promise.all(
    data.map(async pokemon => {
    let pokemonRecord = await getPokemon(pokemon.url);
    return pokemonRecord
  }))
  setPokemonData(_pokemonData)
}
    
  return (
      <Search >
      <Nav>
          <NavCon>
              <NavRow><Navbtn onClick={Home}><Btn style={{color: home ? 'white' : ''}}>Home</Btn></Navbtn></NavRow>
              <NavRow><Navbtn onClick={BReg}><Btn style={{color: reg ? 'white' : ''}}>Regions</Btn></Navbtn></NavRow>
              <NavRow><Navbtn onClick={BTyp}><Btn style={{color: typ ? 'white' : ''}}>Types</Btn></Navbtn></NavRow>
              <NavRow><Navbtn onClick={BSer}><Btn style={{color: ser ? 'white' : ''}}>Search</Btn></Navbtn></NavRow>
          </NavCon>
          <div>
      {reg &&
      <div className="region"><div>
        <button className="region_b" onClick={kanto}>Kanto</button>
        <button className="region_b" onClick={joto}>Johto</button>
        <button className="region_b" onClick={hoenn}>Hoenn</button>
        <button className="region_b" onClick={sinnoh}>Sinnoh</button>
        <button className="region_b" onClick={unova}>Unova</button>
        <button className="region_b" onClick={kalos}>Kalos</button>
        <button className="region_b" onClick={alola}>Alola</button>
        <button className="region_b" onClick={galar}>Galar</button>
        </div>
      </div>}{typ &&
      <div className="region"><div>
        <button className="region_t" style={{backgroundColor:'#A8A77A'}} onClick={Te1}>Normal</button>
        <button className="region_t" style={{backgroundColor:'#C22E28'}} onClick={Te2}>Fighting</button>
        <button className="region_t" style={{backgroundColor:'#A98FF3'}} onClick={Te3}>Flying</button>
        <button className="region_t" style={{backgroundColor:'#A33EA1'}} onClick={Te4}>Poison</button>
        <button className="region_t" style={{backgroundColor:'#E2BF65'}} onClick={Te5}>Ground</button>
        <button className="region_t" style={{backgroundColor:'#B6A136'}} onClick={Te6}>Rock</button>
        <button className="region_t" style={{backgroundColor:'#A6B91A'}} onClick={Te7}>Bug</button>
        <button className="region_t" style={{backgroundColor:'#735797'}} onClick={Te8}>Ghost</button>
        <button className="region_t" style={{backgroundColor:'#B7B7CE'}} onClick={Te9}>Steel</button>
        <button className="region_t" style={{backgroundColor:'#EE8130'}} onClick={Te10}>Fire</button>
        <button className="region_t" style={{backgroundColor:'#6390F0'}} onClick={Te11}>Water</button>
        <button className="region_t" style={{backgroundColor:'#7AC74C'}} onClick={Te12}>Grass</button>
        <button className="region_t" style={{backgroundColor:'#F7D02C'}} onClick={Te13}>Electric</button>
        <button className="region_t" style={{backgroundColor:'#F95587'}} onClick={Te14}>Psychic</button>
        <button className="region_t" style={{backgroundColor:'#96D9D6'}} onClick={Te15}>Ice</button>
        <button className="region_t" style={{backgroundColor:'#6F35FC'}} onClick={Te16}>Dragon</button>
        <button className="region_t" style={{backgroundColor:'#705746'}} onClick={Te17}>Dark</button>
        <button className="region_t" style={{backgroundColor:'#D685AD'}} onClick={Te18}>Fairy</button>
      </div>
      </div>
}{ser &&<div className="region">
<input className="in" placeholder="Search..."  type="text" onKeyDown={handleKeyDown} onChange={(event) =>handleSearch(event)} />
<button className="sr" onClick={search} ><FaSearch /></button>
</div>}
    </div>
      </Nav>
      {home &&<div className="home_ser">
<input className="in2" placeholder="Search..."  type="text" onKeyDown={handleKeyDown} onChange={(event) =>handleSearch(event)} />
<button className="sr2" onClick={search} ><FaSearch /></button>
</div>}<>
     <>{loading ? <div className="mimg" ><img className="bimg" src={ball} /></div> :(
        <>
        <div className="parent">
          {pokemonData.map((pokemon, i) =>{
            return <><Box className="child" key={i} pokemon={pokemon} /></>
          })}
        </div>
        </>
      )}</></>
    </Search>
  );
}

export default withRouter(Main);
